import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useTheme, useViewport } from "@bookingcom/bui-react";
import NotAvailableIllustration from "../../../assets/illustrations/not-available.svg";
import useUserAgent from "../../../hooks/useUserAgent.js";
import { useActions } from "../../../store/index.js";
import { actions as AriaLiveActions } from "../../../store/ariaLive/actions.js";
import { useSelector } from "react-redux";
import { getVisible } from "../../../store/loadingScreen/selectors.js";
import Frame from "../Frame/index.js";
import styles from "./LoadingScreen.module.css";
import NoSSR from "../../../app/NoSSR/index.js";
import { mcn } from "../../../utils/mergeClassnames.js";
const overlayVariants = {
    visible: {
        opacity: 1,
        display: "block"
    },
    hidden: {
        opacity: 0,
        transitionEnd: { display: "none" }
    }
};
const LoadingScreen = (props) => {
    const { illustration: Illustration, title, children, visibleDefault, childrenFullHeight } = props;
    const { isMobile } = useUserAgent();
    const theme = useTheme();
    const { isLarge } = useViewport();
    const visible = useSelector(getVisible);
    const ariaLiveActions = useActions(AriaLiveActions);
    const inlineSvgStyles = { maxWidth: "100%", maxHeight: "100%" };
    useEffect(() => {
        if (visible && title) {
            ariaLiveActions.setMessage({
                message: title,
                type: "assertive"
            });
        }
        else {
            ariaLiveActions.reset();
        }
    }, [ariaLiveActions, visible, title]);
    return (React.createElement(NoSSR, null,
        React.createElement(motion.div, { className: mcn(styles.loadingScreen, !isMobile && styles.loadingScreenDesktop, !isMobile && !isLarge && styles.loadingScreenDesktopRes), variants: overlayVariants, animate: visible || visibleDefault ? "visible" : "hidden", initial: false, "data-testid": props["data-testid"], role: "alertdialog", "aria-label": title },
            React.createElement(Frame, { direction: "column", attributes: { style: { height: "100%" } } },
                React.createElement(Frame, { grow: 1, justifyContent: "center", attributes: { style: { backgroundColor: theme.colors.color_background_base_alt, overflow: "hidden" } } }, Illustration ? (React.createElement(Illustration, { style: inlineSvgStyles })) : (React.createElement(NotAvailableIllustration, { style: inlineSvgStyles }))),
                React.createElement(Frame, { attributes: {
                        style: { background: theme.colors.color_background_base, height: childrenFullHeight ? "auto" : "25%" }
                    }, justifyContent: "center", p: 4 }, children)))));
};
export default LoadingScreen;
